import { StepLabel, stepIconClasses } from '@mui/material';
import { styled } from '@mui/system';

export const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-iconContainer': {
    position: 'relative',
    zIndex: 1,
  },
  [`& .${stepIconClasses.root}`]: {
    position: 'relative',
    zIndex: 1,   
    fontSize: '3rem',
    color: '#e0e0e0',
  },
  [`& .${stepIconClasses.root}.Mui-active`]: {
    color: '#2b97be',
  },
  [`& .${stepIconClasses.root}.Mui-completed`]: {
    color: '#2b97be',
  },
  '& .MuiStepLabel-label': {
    marginTop: '1rem',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '0.8rem',   
  },
}));
